import CodeSnippetInline from "ds/components/CodeSnippetInline";
import Typography from "ds/components/Typography";

const VersionTooltipContent = () => {
  return (
    <>
      <Typography tag="p" variant="p-body3">
        We support strict and loose comparisons as well as ranges defined by SemVer 2.0.0.
      </Typography>
      <Typography tag="p" variant="p-body3">
        E.g:
      </Typography>
      <Typography tag="p" variant="s-body3">
        <CodeSnippetInline>~1.2.3</CodeSnippetInline>
        {` is >=1.2.3 <1.3.0`}
      </Typography>
      <Typography tag="p" variant="s-body3">
        <CodeSnippetInline>^1.2.3</CodeSnippetInline>
        {` is >=1.2.3 <2.0.0`}
      </Typography>
    </>
  );
};

export default VersionTooltipContent;
